"use strict";

export default class ModelCtrl {
  static get UID() {
    return "modelCtrl";
  }

  constructor($state, $stateParams, sceneFac) {
    Object.assign(this, { $state, $stateParams, sceneFac });

    this.model = {};
    this.currentPage = parseInt($stateParams.pageNum, 10) || 1;

    sceneFac.getModel($stateParams.modelId).then(response => {
      this.model = response.model;
      this.scenes = response.scenes;
    });
  }

  pagination(pageNumber) {
    let pn = parseInt(pageNumber, 10) || 1;
    this.$state.go("model", { pageNum, pn });
  }
}



// WEBPACK FOOTER //
// ./src/app/features/modelCtrl.js